// One icon family: 1.8px stroke, round caps, currentColor.
// Never use emoji as UI icons — use these.
import React from "react";

function Base({ size = 20, children, sw = 1.8, filled = false }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? "currentColor" : "none"}
      stroke={filled ? "none" : "currentColor"}
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ flexShrink: 0, display: "block" }}
    >
      {children}
    </svg>
  );
}

export const IconClock = (p) => (
  <Base {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </Base>
);
export const IconPin = (p) => (
  <Base {...p}>
    <path d="M12 21s-7-5.5-7-11a7 7 0 0 1 14 0c0 5.5-7 11-7 11z" />
    <circle cx="12" cy="10" r="2.6" />
  </Base>
);
export const IconTag = (p) => (
  <Base {...p}>
    <path d="M20 13l-7 7-9-9V4h7l9 9z" />
    <circle cx="7.5" cy="7.5" r="1.4" />
  </Base>
);
export const IconPlus = (p) => (
  <Base {...p}>
    <path d="M12 5v14M5 12h14" />
  </Base>
);
export const IconX = (p) => (
  <Base {...p}>
    <path d="M6 6l12 12M18 6L6 18" />
  </Base>
);
export const IconBag = (p) => (
  <Base {...p}>
    <path d="M6 8h15l-1.2 12.2a1 1 0 0 1-1 .8H5.2a1 1 0 0 1-1-.8L3 8" />
    <path d="M9 8V6a3 3 0 0 1 6 0v2" />
  </Base>
);
export const IconLeaf = (p) => (
  <Base {...p}>
    <path d="M5 19C5 9 13 5 20 5c0 8-4 14-13 14" />
    <path d="M5 19c3-5 7-9 11-11" />
  </Base>
);
export const IconExternal = (p) => (
  <Base {...p}>
    <path d="M14 4h6v6" />
    <path d="M20 4L11 13" />
    <path d="M19 13v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6" />
  </Base>
);
export const IconStore = (p) => (
  <Base {...p}>
    <path d="M4 9l1.2-5h13.6L20 9" />
    <path d="M4 9h16v3a2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1-5 0" />
    <path d="M5.5 13.5V20h13v-6.5" />
    <path d="M9.5 20v-5h5v5" />
  </Base>
);
export const IconInfo = (p) => (
  <Base {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5" />
    <circle cx="12" cy="7.8" r="0.4" fill="currentColor" />
  </Base>
);
export const IconFlame = (p) => (
  <Base {...p}>
    <path d="M12 22c4 0 7-2.8 7-6.8 0-3-2-5.3-3.5-7C14 6.5 13 5 13 2c-3 2-5 4.5-5.5 7C6 10 5 11.7 5 14c0 4.5 3 8 7 8z" />
    <path d="M12 22c-1.8 0-3-1.3-3-3 0-1.4 1-2.4 1.8-3.2.7 1 2.2 2 2.2 4.2" />
  </Base>
);
export const IconCheck = (p) => (
  <Base {...p}>
    <path d="M4.5 12.5l5 5 10-11" />
  </Base>
);
export const IconSearch = (p) => (
  <Base {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="M16.5 16.5L21 21" />
  </Base>
);
// ─── Weekly flyer category icons (same 1.8px family) ───
export const IconDrumstick = (p) => (
  <Base {...p}>
    <circle cx="9" cy="9" r="5.2" />
    <path d="M12.6 12.6L16.8 16.8" />
    <circle cx="18.6" cy="16.4" r="1.8" />
    <circle cx="16.4" cy="18.6" r="1.8" />
  </Base>
);
export const IconMilk = (p) => (
  <Base {...p}>
    <path d="M9 8V6.5L12 3l3 3.5V8" />
    <path d="M7.5 8h9V20a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1z" />
    <path d="M7.5 12.5h9" />
  </Base>
);
export const IconSnow = (p) => (
  <Base {...p}>
    <path d="M12 3v18" />
    <path d="M4.2 7.5l15.6 9" />
    <path d="M19.8 7.5l-15.6 9" />
    <path d="M12 3l-2.4 2.4M12 3l2.4 2.4M12 21l-2.4-2.4M12 21l2.4-2.4" />
  </Base>
);
export const IconCookie = (p) => (
  <Base {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <circle cx="9.3" cy="10" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="14.6" cy="9.2" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="11" cy="14.6" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="15" cy="13.8" r="1.1" fill="currentColor" stroke="none" />
  </Base>
);
export const IconBaby = (p) => (
  <Base {...p}>
    <path d="M10.5 7V5.2a1.6 1.6 0 0 1 3 0V7" />
    <path d="M10 7h4v2.5h-4z" />
    <path d="M9.5 9.5h5V19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2z" />
    <path d="M9.5 14h5" />
  </Base>
);
export const IconSpray = (p) => (
  <Base {...p}>
    <path d="M10.5 12V9.5h3V12" />
    <path d="M10.5 9.5V7H17" />
    <path d="M17 7l2.6.8" />
    <path d="M13.5 9.5L11.5 12" />
    <path d="M9.5 12h5V20a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1z" />
    <path d="M20.6 8.6l1.7 1.1M21.2 5.9l1.9-.3" />
  </Base>
);
// ─── v1.3: badge + location icons (same 1.8px family) ───
export const IconMegaphone = (p) => (
  <Base {...p}>
    <path d="M4 10.5L16 5.5v13L4 13.5v-3z" />
    <path d="M8 14.3V20" />
    <path d="M19 9.5a3.5 3.5 0 0 1 0 5" />
  </Base>
);
export const IconStar = (p) => (
  <Base {...p}>
    <path d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9-5.2-2.8-5.2 2.8 1-5.9-4.3-4.1 5.9-.8z" />
  </Base>
);
export const IconTrophy = (p) => (
  <Base {...p}>
    <path d="M7 4h10v4.5a5 5 0 0 1-10 0V4z" />
    <path d="M7 5.5H4.8c0 3 2 4.5 4.2 4.7" />
    <path d="M17 5.5h2.2c0 3-2 4.5-4.2 4.7" />
    <path d="M12 13.5V17" />
    <path d="M8.5 20h7" />
  </Base>
);
export const IconMoon = (p) => (
  <Base {...p}>
    <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4 8.5 8.5 0 1 0 20 14.5z" />
  </Base>
);
export const IconShieldCheck = (p) => (
  <Base {...p}>
    <path d="M12 3l7 2.8v5.4c0 4.5-3 7.6-7 9.8-4-2.2-7-5.3-7-9.8V5.8L12 3z" />
    <path d="M9 11.5l2.2 2.2 4-4.5" />
  </Base>
);
export const IconSpark = (p) => (
  <Base {...p}>
    <path d="M12 3l1.8 6.2L20 11l-6.2 1.8L12 19l-1.8-6.2L4 11l6.2-1.8z" />
  </Base>
);
export const IconRefresh = (p) => (
  <Base {...p}>
    <path d="M21 12a9 9 0 1 1-2.64-6.36" />
    <path d="M21 3v6h-6" />
  </Base>
);
export const IconUser = (p) => (
  <Base {...p}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4.5 20a7.5 7.5 0 0 1 15 0" />
  </Base>
);
// ─── v2.0: grocery list, meal picker, map (same 1.8px family) ───
export const IconCart = (p) => (
  <Base {...p}>
    <path d="M3.5 5h2.2l2.3 11.2a1 1 0 0 0 1 .8H18a1 1 0 0 0 1-.8L20.5 8H7" />
    <circle cx="9.5" cy="20" r="1.3" />
    <circle cx="17.5" cy="20" r="1.3" />
  </Base>
);
export const IconBowl = (p) => (
  <Base {...p}>
    <path d="M4 12h16a8 8 0 0 1-16 0z" />
    <path d="M9.5 12c0-2 .8-3.5 2.5-4.5" />
    <path d="M12 7.5c.6-1.6 1.6-2.6 3-3" />
  </Base>
);
export const IconMap = (p) => (
  <Base {...p}>
    <path d="M9 4L3.5 6v14L9 18l6 2 5.5-2V4L15 6 9 4z" />
    <path d="M9 4v14" />
    <path d="M15 6v14" />
  </Base>
);
export const IconBookmark = (p) => (
  <Base {...p}>
    <path d="M6.5 3.5h11V21l-5.5-4.2L6.5 21z" />
  </Base>
);
// ─── Mascot: "Baggy" the grocery bag ─────────────────────────────────────
// Winking mascot for empty states — restraint with a wink. Flat fills,
// no gradients, same rounded geometry as the icon family.
export const Mascot = ({ size = 84 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 96 96"
    fill="none"
    aria-hidden="true"
    style={{ display: "block" }}
  >
    {/* sprout */}
    <path
      d="M48 22c0-6 4-10 10-11-1 6-5 10-10 11z"
      fill="#1F7A4D"
    />
    <path d="M48 24v6" stroke="#1F7A4D" strokeWidth="3" strokeLinecap="round" />
    {/* bag */}
    <rect x="24" y="30" width="48" height="46" rx="11" fill="#1F7A4D" />
    <rect x="24" y="30" width="48" height="46" rx="11" fill="#000" opacity="0.08" />
    {/* folded top */}
    <path
      d="M24 41c8-3 16 3 24 0s16 3 24 0v-0h-48z"
      fill="#fff"
      opacity="0.22"
    />
    {/* wink face */}
    <circle cx="40" cy="54" r="3.4" fill="#fff" />
    <path
      d="M52 54h7"
      stroke="#fff"
      strokeWidth="3.2"
      strokeLinecap="round"
    />
    <path
      d="M39 63q9 8 18 0"
      stroke="#fff"
      strokeWidth="3.2"
      strokeLinecap="round"
    />
    {/* cheek */}
    <circle cx="60" cy="60" r="2.6" fill="#fff" opacity="0.45" />
  </svg>
);
